export const SET_ACTIVITIES = 'activity/SET_ACTIVITIES';
export const ADD_ACTIVITY = 'activity/ADD_ACTIVITY';
export const UPDATE_ACTIVITY = 'activity/UPDATE_ACTIVITY';